module.exports = __webpack_public_path__ + "static/media/pos.bb1ee442.png";